// Create Assignment
export const CREATE_ASSIGNMENT_REQUEST = 'CREATE_ASSIGNMENT_REQUEST';
export const CREATE_ASSIGNMENT_DONE = 'CREATE_ASSIGNMENT_DONE';
export const CREATE_ASSIGNMENT_FAILED = 'CREATE_ASSIGNMENT_FAILED';
export const CREATE_ASSIGNMENT_CLEAR_ERRORS = 'CREATE_ASSIGNMENT_CLEAR_ERRORS';
export const CREATE_ASSIGNMENT_RESET = 'UPDATE_ASSIGNMENT_RESET';